import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0',
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  }
}));

function getSteps() {
  return [
    'ECD',
    'Bancos e Caixas',
    'Obrigação Acessória',
    'NF Serviços prestados',
    'Livro Caixa do Produtor Rural',
    'XML de saídas', 
    'XML de entradas', 
    'SPED Fiscal', 
    'SPED Contribuições', 
    'SEFIP', 
    'DCTF', 
    'DIRF', 
    'ECF'
  ];
}

export default function VerticalLinearStepper({activeStep} : {activeStep: number}) {
  const classes = useStyles();
  const steps = getSteps();
  
  return <div className={classes.root}>
    <Stepper activeStep={activeStep} orientation="vertical">
      {steps.map((x, index) => (
        <Step key={index}>
          <StepLabel>{x}</StepLabel>
          <StepContent>
            <Typography />
          </StepContent>
        </Step>
      ))}
    </Stepper>
  </div>
}
